import React, { Component } from "react"
import { connect } from "react-redux"
import styled, { injectGlobal, css } from 'styled-components'
import Link from "gatsby-link"
import { find } from 'lodash'

import { Block, MetaTags, Footer, Section } from '../components'
import BlockSectionOpening from "../components/Block/templates/BlockSectionOpening";

import { fetchSettings, getSettings } from '../store/settings'

import { warmBrown } from '../styles/themes'
import { container, heading, bgImage, button, bgIcon, innerContainer } from "../styles/global"
import logo from '../assets/images/logo.svg'
import { paragraph, caption } from "../styles/type";
import { media, isClient } from "../styles/utils";

class Profile extends Component {

	state = {
		sections: [],
		history: [],
		history_title: null,
		history_introduction: null
    }
    
    componentWillMount = () => {
        this.props.fetchSettings()
    }
		
	componentDidMount = () => {
		const data = this.props.data.wordpressProfile;

		this.setState({
			sections: JSON.parse(data.acf_json).sections,
			history: JSON.parse(data.acf_json).history,
			history_title: JSON.parse(data.acf_json).history_title,
			history_introduction: JSON.parse(data.acf_json).history_introduction,
		})
	}

	renderBlocks = (blocks) => {
		return blocks.map((block, i) => {                
			return (
				<Block
					layout={block.acf_fc_layout}
					key={i}
					{...block}
				/>
			)
		})
	}

	renderSections = () => {
		const { sections } = this.state;

		return sections.map((section, i) => {
			const blocks = section.blocks;

			if (section.display_section && section.blocks) {
				return (
					<Section
						key={i}
						blocks={blocks}
						section={section}
					/>
				)
			}
		})
	}

	renderHistoryItems = () => {
		const { history } = this.state;

		if (history) {
			return history.map((item, i) => {
				return (
					<HistoryItem
						key={i}
					>
						<Heading
							dangerouslySetInnerHTML={{__html: item.heading}}  
						/>
						<Description
							dangerouslySetInnerHTML={{__html: item.details}}  
						/>
					</HistoryItem>
				)
			})
		}
	}

	renderHistory = () => {
		const { history_title, history_introduction } = this.state;

		return (
			<History>
				<BlockSectionOpening
					title={history_title}
					paragraph={history_introduction}
				/>
				<HistoryItems>
					{this.renderHistoryItems()}
				</HistoryItems>
			</History>
		)
	}

  	render() {
        const { data } = this.state;
        const splashActive = this.props.settings.splashActive;

		return (
			<Wrapper
                active={splashActive == false}
            >

                <MetaTags 
                    title={`Paul Conrad Architects — Profile`}
                />

				{this.renderSections()}
                {this.renderHistory()}
                
                <Footer 
                    title={'Profile'}
                    pageURL={isClient() ? window.location.href : '' }
                    backLink={'/'}
                    backLinkText={'Back to Home'}
                />

			</Wrapper>
		)	
  	}
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;	
	width: 100%;
	z-index: 2;
	overflow-x: hidden;
    transition: all 0.75s ease;
	transition-delay: 0.4s;
	will-change: transform;
    transform: translateY(100px);
	opacity: 0;

	${props => {
		if (props.active) return css`
			transform: translateY(0);
			opacity: 1;
		`
	}}
`


// Shared

const Heading = styled.div``
const Description = styled.div``


// History

const History = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	margin-bottom: 15rem;
	padding-top: 15rem;
	border-top: 1px solid rgba(0,0,0,0.08);
`

const HistoryItems = styled.div`
	${innerContainer};
	column-count: 2;
	column-gap: 5rem;
	margin-top: 10rem;

	${media.tablet`
		column-count: initial;
		display: flex;
		flex-direction: column;
		align-items: center;
	`}
`

const HistoryItem = styled.div`
	break-inside: avoid;
	
	&:not(:first-child) {
		margin-top: 3rem;
	}

	${media.tablet`
		width: 360px;
		max-width: 100%;
	`}

	${Heading} {
		&, * {
			${paragraph};
		}
	}
	${Description} {
		margin-top: 1rem;

		&, * {
			${caption};
			text-indent: 0!important;
		}
	}
`


const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile);


export const pageQuery = graphql`
	query Profile {
		wordpressProfile {
			acf_json
		}
	}
`


// WEBPACK FOOTER //
// ./src/pages/Profile.js